import React from 'react';
import ShopListing from '../components/shop/ShopListing';

// /shops — toda la tienda; la categoría elegida viaja en ?category=
const Shops = () => <ShopListing />;

export default Shops;
